import React from 'react';

export default () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='16'
    height='16'
    viewBox='0 0 16 16'
  >
    <path d='M9.575 3.182a.146.146 0 0 1 .102.249L6.242 6.865c-.112.112-.2.246-.259.393l-.824 2.06c-.173.434-.071.93.259 1.26.332.325.824.426 1.258.257l2.062-.827c.147-.058.28-.146.392-.258l3.434-3.432a.146.146 0 0 1 .249.104v6.608a1.818 1.818 0 0 1-1.819 1.818h-8.03a1.818 1.818 0 0 1-1.818-1.818V5c0-1.004.814-1.818 1.819-1.818zm1.844-.257a.3.3 0 0 1 .412 0l1.238 1.238a.292.292 0 0 1 0 .413L8.511 9.133a.292.292 0 0 1-.098.065l-2.062.825a.303.303 0 0 1-.314-.064.292.292 0 0 1-.065-.315l.825-2.063a.296.296 0 0 1 .064-.098zm1.444-1.443a1.195 1.195 0 0 1 1.65 0 1.167 1.167 0 0 1 0 1.65l-.617.618a.264.264 0 0 1-.034.023.282.282 0 0 1-.379-.023l-1.239-1.237a.292.292 0 0 1-.085-.206.286.286 0 0 1 .06-.17.31.31 0 0 1 .025-.036z' />
  </svg>
);
